/// <reference lib="dom" />
const getAugLoopTextEncoding = () => {
    if (typeof TextEncoder === 'undefined' || typeof TextDecoder === 'undefined') {
        /* eslint-disable-next-line @typescript-eslint/no-require-imports */
        require('fast-text-encoding');
        const textEncoding = {
            AugLoopTextEncoder: TextEncoder,
            AugLoopTextDecoder: TextDecoder
        };
        // eslint-disable-next-line no-global-assign
        TextEncoder = undefined;
        // eslint-disable-next-line no-global-assign
        TextDecoder = undefined;
        return textEncoding;
    }
    else {
        return {
            AugLoopTextEncoder: TextEncoder,
            AugLoopTextDecoder: TextDecoder
        };
    }
};
// eslint-disable-next-line @typescript-eslint/naming-convention
export const { AugLoopTextEncoder, AugLoopTextDecoder } = getAugLoopTextEncoding();
//# sourceMappingURL=augloop-text-encoding.js.map